var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h5", [
              _vm._v(
                _vm._s(_vm.$t("message.dashboardContentContactPerson.message"))
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(Math.ceil(_vm.policyHolders.length / 2), function(i) {
        return _c(
          "b-row",
          { key: i, staticClass: "mt-3" },
          _vm._l(_vm.policyHolders.slice((i - 1) * 2, i * 2), function(
            policyHolder
          ) {
            return _c(
              "b-col",
              { key: policyHolder.id, attrs: { cols: "12", xl: "6" } },
              [
                _c(
                  "b-btn",
                  {
                    staticClass: "p-0 m-0 w-100",
                    attrs: {
                      variant: "transparent",
                      "router-tag": "div",
                      to: "/policyHolders/" + policyHolder.id
                    }
                  },
                  [
                    _c(
                      "business-card",
                      {
                        staticClass: "rounded-0 h-100",
                        attrs: {
                          name:
                            policyHolder.firstName +
                            " " +
                            policyHolder.lastName,
                          relation: _vm.$t(
                            "enums.relationTypes." +
                              policyHolder.relationshipType
                          ),
                          email: policyHolder.email,
                          imageSrc: policyHolder.avatarUuid,
                          showIcon: !!policyHolder.dateOfDeath,
                          dateOfDeath: policyHolder.dateOfDeath
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "bcFooter" }, slot: "bcFooter" },
                          [
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-row" },
                              [
                                _c("b-badge", { staticClass: "p-2 mr-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        policyHolder.numberOfAssignedContracts
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getNumberOfAssignedContractsText(
                                          policyHolder
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        )
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                {
                  staticClass: "rounded-0",
                  attrs: {
                    title: _vm.$t(
                      "message.dashboardContentContactPerson.insurance.title"
                    )
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.dashboardContentContactPerson.insurance.message"
                          )
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.submit($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-for": "dateOfBirth",
                                    state: _vm.$v.regData.dateOfBirth.$error
                                      ? false
                                      : null,
                                    "invalid-feedback": _vm.$t(
                                      "error.dashboardContentContactPerson.dateOfBirth"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.dashboardContentContactPerson.insurance.label.dateOfBirth"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("*")]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    staticClass: "rounded-0",
                                    attrs: {
                                      id: "dateOfBirth",
                                      placeholder: "TT.MM.JJJJ",
                                      state: _vm.$v.regData.dateOfBirth.$error
                                        ? false
                                        : null
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$v.regData.dateOfBirth.$touch()
                                      }
                                    },
                                    model: {
                                      value: _vm.regData.dateOfBirth,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.regData,
                                          "dateOfBirth",
                                          $$v
                                        )
                                      },
                                      expression: "regData.dateOfBirth"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-for": "contractNumber",
                                    state: _vm.$v.regData.contractNumber.$error
                                      ? false
                                      : null,
                                    "invalid-feedback": _vm.$t(
                                      "error.dashboardContentContactPerson.contractNumber"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.dashboardContentContactPerson.insurance.label.contractNumber"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("*")]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    staticClass: "rounded-0",
                                    attrs: {
                                      id: "contractNumber",
                                      state: _vm.$v.regData.contractNumber
                                        .$error
                                        ? false
                                        : null
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$v.regData.contractNumber.$touch()
                                      }
                                    },
                                    model: {
                                      value: _vm.regData.contractNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.regData,
                                          "contractNumber",
                                          $$v
                                        )
                                      },
                                      expression: "regData.contractNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "rounded-0",
                                  attrs: { variant: "primary", type: "submit" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.dashboardContentContactPerson.insurance.btn.submit"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c451cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c451cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardContentContactPerson.vue
// module id = HQRp
// module chunks = 1